import React from 'react'

export default function SpotSnapLeaderboard() {
  return (
    <div>SpotSnapLeaderboard</div>
  )
}
